import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  UncontrolledPopover,
} from "reactstrap";
import { useReferralLinkBuilder } from "../../../hooks/useReferralLinkBuilder";
import UserStatusBadge from "../../Badges/UserStatusBadge";

const PromoCodeModal = ({
  promoCodes,
  open,
  setOpen,
  loading,
  currentUser,
  onAddPromoCode,
}) => {
  const {
    createIndividualReferralLinkFromPromoCode,
  } = useReferralLinkBuilder();

  const referralUrl = createIndividualReferralLinkFromPromoCode(promoCodes?.code);


  const [isCopied, setIsCopied] = useState(false);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };

  const handleCopyPromoCode = (code, id) => {
    navigator.clipboard.writeText(code).then(() => {
      setIsCopied(id);
      setTimeout(() => setIsCopied(null), 2000);
    });
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralUrl).then(() => {
      setIsLinkCopied(true);
      setTimeout(() => setIsLinkCopied(false), 2000);
    });
  };
  const handleAddPromoCode = async () => {
    onAddPromoCode();
  };

  useEffect(() => { }, [promoCodes, currentUser]);

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Referral page</ModalHeader>

      <ModalBody>
        {promoCodes ? (
          <div className="d-flex align-items-center">
            <p className="my-0 ps-2">Referral link: </p>
            <span className="ms-1 text-primary">{referralUrl}</span>
            <Button
              id="copyLink"
              onClick={handleCopyLink}
              color="soft-dark"
              className="ms-2 me-3 p-1 py-0 d-flex align-items-center justify-content-center "
            >
              {isLinkCopied ? (
                <i className="ri-check-line"></i>
              ) : (
                <i className="ri-file-copy-line"></i>
              )}
            </Button>
            <UncontrolledPopover
              onClick={(e) => e.stopPropagation()}
              placement="bottom"
              target={`copyLink`}
              trigger="hover"
            >
              <PopoverBody className="p-1">
                {isLinkCopied ? "Copied" : "Copy your referral link"}
              </PopoverBody>
            </UncontrolledPopover>
          </div>
        ) : null}
        {!promoCodes ? (
          <div className="mt-4  d-flex flex-column justify-content-center align-items-center">
            <p className="text-center">You don't have any promo codes yet</p>
            <Button
              disabled={loading}
              onClick={handleAddPromoCode}
              color="primary"
              className="d-flex align-items-center "
            >
              <i className="ri-add-line"></i> Claim One
            </Button>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Promo Code</th>
                <th>Discount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="d-flex">
                  {promoCodes.code}
                  <Button
                    id="copyInviteCode"
                    onClick={() =>
                      handleCopyPromoCode(promoCodes.code, promoCodes.id)
                    }
                    color="soft-dark"
                    className="ms-2 me-3 p-1 py-0 d-flex align-items-center justify-content-center "
                  >
                    {isCopied ? (
                      <i className="ri-check-line"></i>
                    ) : (
                      <i className="ri-file-copy-line"></i>
                    )}
                  </Button>
                  <UncontrolledPopover
                    onClick={(e) => e.stopPropagation()}
                    placement="bottom"
                    target={`copyInviteCode`}
                    trigger="hover"
                  >
                    <PopoverBody className="p-1">
                      {isCopied ? "Copied" : "Copy your Promo code"}
                    </PopoverBody>
                  </UncontrolledPopover>
                </td>

                <td>{promoCodes.discount}%</td>
                <td>
                  <UserStatusBadge
                    status={promoCodes.active ? "Active" : "Inactive"}
                    color={promoCodes.active === true ? "success" : "danger"}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="soft-primary" className="border border-primary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PromoCodeModal;
